import { PageSize } from 'gf-types';
import * as Permissions from '../usersgroups/groups/permission_enum';

/**
 * Gets the filter parameters for the template lists.
 */
export function getTemplateFilterParams(
  isPublished: boolean,
  pageSize: PageSize | number,
  page: number,
  search?: string,
  folderId?: string,
  includeFolders = true,
  onlyIncludeTemplatesInRoot = false,
  subFolders = false
): URLSearchParams {
  const params = new URLSearchParams();

  if (search) {
    //params.push(`name=${encodeURIComponent(search)}`);
    params.set('filter', `contains(Name, '${search.replace(/'/g, "''")}') eq true`);
  } else if (includeFolders) {
    params.set('includeFolders', 'true');
  }

  if (folderId) {
    params.set('folderId', folderId);
  } else if (onlyIncludeTemplatesInRoot) {
    params.set('onlyIncludeTemplatesInRoot', 'true');
  }

  if (subFolders) {
    params.set('subFolders', 'true');
  }

  if (isPublished) {
    params.set('publishedOnly', 'true');
  }

  params.set('take', pageSize.toString());
  params.set('skip', `${pageSize * (page - 1)}`);

  return params;
}

export function isDisabledThroughInheritance(props, flag) {
  //This is to prevent the child group from having less permission than the parent group from the folder view
  const shouldDisableInheritedPermission = props?.parentId && (flag & props?.parentPermission) != 0;

  return props?.inheritedPermissions ? Permissions.HasPermission(props?.inheritedPermissions, flag) : shouldDisableInheritedPermission;
}
